import { forwardRef } from "react";

const MenuItem = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
  }
>(({ children, disabled, ...props }, ref) => {
  return (
    <>
      <button
        {...props}
        className="menu-item"
        ref={ref}
        role="menuitem"
        disabled={disabled}
      >
        {children}
      </button>
      <style jsx>{`
        .menu-item {
          display: flex;
          height: 24px;
          padding: 0px 4px;
          align-items: center;
          gap: 10px;
          align-self: stretch;
          outline: 0;
          border-radius: 4px;

          color: #fff;

          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 153.846% */

          &:hover {
            background: #4a4a4a;
          }
        }
      `}</style>
    </>
  );
});

MenuItem.displayName = "MenuItem";

export default MenuItem;
